exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error-border[data-v-d37de060] {\n    border-color: #e9605c\n}\n", ""]);

// exports
